<div class="questionModel.cssClasses.root" *ngIf="questionModel.visible !== false">
  <div class="sd-element__title sd-question__title sd-question__title--answer sd-question__title--required sd-title"
       *ngIf="questionModel.title">
    <p class="mb-0" [ngClass]="{'pb-3' : !questionModel.description}">
      <span>{{ questionModel.title }}</span>
      <span class="required-control" *ngIf="questionModel.isRequired">*</span>
    </p>
    <div class="sd-question__description--under-input" *ngIf="questionModel.description">
      <span class="sv-string-viewer question-hint" style="position: static;">{{ questionModel.description }}</span>
    </div>
  </div>
  <div id="tg-sv-dropdown" class="sv-dropdown_select-wrapper"
       [ngClass]="{'form-control-dropdown-without-error' : !hasErrors()}"
       (blur)="toggleDropdown()"
       (keydown.esc)="toggleDropdown(true)"
       (keydown.tab)="toggleDropdown(true)"
       (click)="toggleDropdown()">
    <div class="sd-dropdown sd-input"
         role="listbox"
         tabindex="0"
         [ngClass]="{'form-control-background-error' : hasErrors()}"
         #dropdownContainer>

      <div class="sd-dropdown__value">
        <input class="sd-dropdown__filter-string-input"
               type="text"
               (input)="filterOptions()"
               [placeholder]="getSelectedText() || questionModel['placeholder'] || 'Select...'"
               [(ngModel)]="searchText"
               #searchInput>
      </div>
      <div aria-hidden="true" class="sd-dropdown_clean-button">
        <svg sv-ng-svg-icon
             role="img" class="sd-dropdown_clean-button-svg sv-svg-icon">
          <use xlink:href="#icon-cancel-24x24"></use>
          <title>Clear</title></svg>
      </div>

      <div class="sd-dropdown_chevron-button">
        <svg class="sd-dropdown_clean-button-svg sv-svg-icon">
          <use [attr.xlink:href]="isOpen ? '#icon-arrow_up' : '#icon-arrow_down'"></use>
        </svg>
      </div>

      <div
        *ngIf="isOpen"
        style="display: contents"
        [style.top.px]="dropdownTop"
        [style.left.px]="dropdownLeft"
        [style.width.px]="dropdownWidth">
        <div class="sv-popup__container tg-popup-container" #optionsContainer>
          <div class="sv-list__empty-text p-3 py-2" *ngIf="!getOptions() || getOptions().length === 0">No data to
            display
          </div>
          <div *ngFor="let option of getOptions(); let i = index"
               [ngClass]="{
       'sd-list__item--selected sv-list__item--selected': option.value === questionModel.value,
       'sd-list__item--focused': i === focusedOptionIndex}"
               class="sd-list__item sv-list__item sv-list__item-text--wrap tg-popup-option"
               role="option"
               (click)="selectOption(option.value)">
            {{ option.label }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sd-element__erbox sd-error sd-question__erbox sd-question__erbox--below-question"
       *ngIf="hasErrors()">
    <div class="sd-question__erbox-message">
      {{ getErrorMessage() }}
    </div>
  </div>
</div>
